import i18n from '@/lib/i18n';

/**
 * Get translated test title for Level 1
 */
export const getTestTitle = (testId: string): string => {
  const testKeys = {
    // Putting tests
    'putts-plat': 'level1.tests.putting.putts-plat.title',
    'putts-montee': 'level1.tests.putting.putts-montee.title',
    'putts-descente': 'level1.tests.putting.putts-descente.title',
    'putts-pente': 'level1.tests.putting.putts-pente.title',
    'putts-pente-droite': 'level1.tests.putting.putts-pente-droite.title',
    
    // Chipping tests
    'chipping-plat': 'level1.tests.chipping.chipping-plat.title',
    'chipping-pente-droit': 'level1.tests.chipping.chipping-pente-droit.title',
    'chipping-roulee-plat': 'level1.tests.chipping.chipping-roulee-plat.title',
    
    // Wedging tests
    'wedging-cercles': 'level1.tests.wedging.wedging-cercles.title',
    'wedging-pente-gauche': 'level1.tests.wedging.wedging-pente-gauche.title',
    'wedging-mid': 'level1.tests.wedging.wedging-mid.title',
    
    // Bunker tests
    'bunker-court': 'level1.tests.bunker.bunker-court.title',
    'bunker-long': 'level1.tests.bunker.bunker-long.title',
    
    // Iron tests
    'iron-long': 'level1.tests.iron.iron-long.title',
    'iron-mid': 'level1.tests.iron.iron-mid.title',
    'iron-green-attack': 'level1.tests.iron.iron-green-attack.title',
    'iron-green-attack-100': 'level1.tests.iron.iron-green-attack-100.title',
    
    // Fairway wood tests
    'fairwayWood-3': 'level1.tests.fairwayWood.fairwayWood-3.title',
    'fairwayWood-5': 'level1.tests.fairwayWood.fairwayWood-5.title',
    
    // Driver tests
    'driver-practice': 'level1.tests.driver.driver-practice.title',
    'driver-accuracy': 'level1.tests.driver.driver-accuracy.title'
  };

  const translationKey = testKeys[testId as keyof typeof testKeys];
  if (translationKey) {
    return i18n.t(translationKey, { ns: 'training' });
  }
  
  console.log(`Fallback to hardcoded data for test title: ${testId}`);
  return testId;
};

/**
 * Get translated test description for Level 1
 */
export const getTestDescription = (testId: string): string => {
  const testKeys = {
    // Putting tests
    'putts-plat': 'level1.tests.putting.putts-plat.description',
    'putts-montee': 'level1.tests.putting.putts-montee.description',
    'putts-descente': 'level1.tests.putting.putts-descente.description',
    'putts-pente': 'level1.tests.putting.putts-pente.description',
    'putts-pente-droite': 'level1.tests.putting.putts-pente-droite.description',
    
    // Chipping tests
    'chipping-plat': 'level1.tests.chipping.chipping-plat.description',
    'chipping-pente-droit': 'level1.tests.chipping.chipping-pente-droit.description',
    'chipping-roulee-plat': 'level1.tests.chipping.chipping-roulee-plat.description',
    
    // Wedging tests
    'wedging-cercles': 'level1.tests.wedging.wedging-cercles.description',
    'wedging-pente-gauche': 'level1.tests.wedging.wedging-pente-gauche.description',
    'wedging-mid': 'level1.tests.wedging.wedging-mid.description',
    
    // Bunker tests
    'bunker-court': 'level1.tests.bunker.bunker-court.description',
    'bunker-long': 'level1.tests.bunker.bunker-long.description',
    
    // Iron tests
    'iron-long': 'level1.tests.iron.iron-long.description',
    'iron-mid': 'level1.tests.iron.iron-mid.description',
    'iron-green-attack': 'level1.tests.iron.iron-green-attack.description',
    'iron-green-attack-100': 'level1.tests.iron.iron-green-attack-100.description',
    
    // Fairway wood tests
    'fairwayWood-3': 'level1.tests.fairwayWood.fairwayWood-3.description',
    'fairwayWood-5': 'level1.tests.fairwayWood.fairwayWood-5.description',
    
    // Driver tests
    'driver-practice': 'level1.tests.driver.driver-practice.description',
    'driver-accuracy': 'level1.tests.driver.driver-accuracy.description'
  };

  const translationKey = testKeys[testId as keyof typeof testKeys];
  if (translationKey) {
    return i18n.t(translationKey, { ns: 'training' });
  }
  
  console.log(`Fallback to hardcoded data for test description: ${testId}`);
  return testId;
};